/* Required Terms & Conditions acknowledgment on the cart page.
 * This protects only checkout actions; cart quantity updates remain normal
 * full-page form submissions as required by the store's cart behavior.
 */
(function () {
  var STORAGE_KEY = 'cp_terms_acknowledged';

  function hasAgreed() {
    try { return window.sessionStorage.getItem(STORAGE_KEY) !== 'no'; }
    catch (error) { return true; }
  }

  function saveAgreement(agreed) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, agreed ? 'yes' : 'no');
    } catch (error) {
      // The control still works on the current page if storage is unavailable.
    }
  }

  function getCheckbox() { return document.getElementById('TermsAcknowledgment'); }
  function getError() { return document.getElementById('TermsAcknowledgmentError'); }

  function updateCheckoutState() {
    var checkbox = getCheckbox();
    var checkout = document.getElementById('checkout');
    if (!checkbox || !checkout) return;

    var agreed = hasAgreed();
    checkbox.checked = agreed;
    checkout.disabled = !agreed;
    checkout.setAttribute('aria-disabled', agreed ? 'false' : 'true');
    var error = getError();
    if (agreed && error) error.hidden = true;
  }

  function showRequiredError() {
    var checkbox = getCheckbox();
    var error = getError();
    if (error) error.hidden = false;
    if (checkbox) {
      checkbox.setAttribute('aria-invalid', 'true');
      checkbox.focus();
    }
  }

  function isAcceleratedCheckoutTarget(target) {
    return !!(target && typeof target.closest === 'function' && target.closest(
      '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-accelerated-checkout'
    ));
  }

  function isStandardCheckoutTarget(target) {
    return !!(target && (target.id === 'checkout' || (
      typeof target.closest === 'function' && target.closest('#checkout')
    )));
  }

  document.addEventListener('DOMContentLoaded', updateCheckoutState);

  document.addEventListener('change', function (event) {
    if (!event.target || event.target.id !== 'TermsAcknowledgment') return;
    saveAgreement(event.target.checked);
    event.target.setAttribute('aria-invalid', 'false');
    updateCheckoutState();
  });

  // Capture checkout clicks before theme/form or accelerated-checkout handlers.
  document.addEventListener('click', function (event) {
    if (!isStandardCheckoutTarget(event.target) && !isAcceleratedCheckoutTarget(event.target)) return;
    if (hasAgreed()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showRequiredError();
  }, true);

  // Do not interfere with cart quantity +/- full-page form submissions.
  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'cart' || hasAgreed()) return;
    if (!isStandardCheckoutTarget(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showRequiredError();
  }, true);

  // Cart updates replace the footer. Reapply consent state to its fresh controls.
  var footer = document.getElementById('main-cart-footer');
  if (footer && footer.parentNode) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.id === 'main-cart-footer' ||
            (node.querySelector && node.querySelector('#main-cart-footer')));
        });
      })) updateCheckoutState();
    }).observe(footer.parentNode, { childList: true });
  }
})();
